import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { ITipo } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { TipoService } from "../../../services/catalogos/tipo/tipo.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoTipooStatus } from "../../../states/admon-catalogos/selector";
import { cargaTipo } from "../../../states/catalogos/actions";
import {
  campoRequerido,
  descripcionCatalogo,
  existeValorDuplicado
} from "../../utils";
import { NuevoTipoComponent } from "../nuevo/nuevo.component";

@Component({
  selector: "app-lista",
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    NuevoTipoComponent,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: "./lista.component.html",
  styleUrl: "./lista.component.css",
})
export class ListaTipoComponent {
  tipos: ITipo[] = [];
  registroSeleccionado!: ITipo | null;
  ocultarVistaLectura = false;
  editandoRegistro = false;
  mostrarBotones = true;
  editarForm!: FormGroup;

  private store: Store<AppState> = inject(Store);
  admonCatTiposStatus$ = this.store.pipe(select(selectCatalogoTipooStatus));

  constructor(
    private tipoService: TipoService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadingService.show();
    this.editarForm = this.fb.group({
      descripcion: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });

    this.tipoService.cargarTipo().subscribe(
      (response) => {
        this.tipos = response;
        this.loadingService.hide();
        console.log("Tipo cargado:", this.tipos);
        // Realizar otras acciones después de cargar las empresas
        console.log("Cargamos empresas en app store");
        this.store.dispatch(cargaTipo({ catTipo: response }));
      },
      (error) => {
        this.loadingService.hide();
      }
    );
  }

  editarRegistro(tipo: ITipo | null): void {
    this.registroSeleccionado = tipo;

    this.editarForm.setValue({
      descripcion: tipo?.descripcion || "",
    });
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "tipos",
        mostrarEditar: true,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  cancelarEdicion() {
    this.editarForm.setValue({
      descripcion: "",
    });
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "tipos",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  guardarCambios(data: ITipo) {
    this.loadingService.show();
    if (this.editarForm.valid) {
      this.tipoService
        .editarTipo({
          ...data,
          descripcion: this.editarForm.value.descripcion,
        })
        .subscribe((data) => {
          console.log("data", data.error);
          if (!data.error) {
            this.store.dispatch(
              showHideCatalogo({
                tipoCatalogo: "tipos",
                mostrarEditar: false,
                mostrarNuevo: false,
                guardando: false,
              })
            );
          }
          this.loadingService.hide();
        });
    }
  }
  eliminarTipo(tipo: ITipo): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Advertencia",
        message: "¿Estás seguro que quieres eliminar el elemento?",
        showButtons: {
          accept: true,
          cancel: true,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "CONFIRMAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      this.loadingService.show();
      this.tipoService.eliminarTipo(tipo.id).subscribe((data) => {
        if (data.error) {
          this.cancelarEdicion();
        }
      });
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
  }
  existeRegistro(control: any, currentValue: any) {
    existeValorDuplicado(control, this.tipos, currentValue);
  }
}
